import type { UpdateOrderAddressInput } from '@repo/api-contracts';
import { useInvalidateMyOrders } from '@/entities/order';
import { trpc } from '@/shared/api';

export interface UseUpdateOrderAddressResult {
  /** 실패하면 서버 오류를 그대로 던진다 — 문구·상태 충돌 재조회는 배송지 대화상자가 맡는다. */
  readonly updateAddress: (input: UpdateOrderAddressInput) => Promise<void>;
  readonly isPending: boolean;
}

/**
 * 고객 배송지 변경(orders.updateShippingAddress, 주문 설계 §8-3). 성공 응답(최신 상세)을 캐시에 넣는다 — 배송지는 목록·견적
 * 화면에 보이지 않아 다른 캐시는 그대로 둔다.
 */
export const useUpdateOrderAddress = (): UseUpdateOrderAddressResult => {
  const orders = useInvalidateMyOrders();
  const mutation = trpc.orders.updateShippingAddress.useMutation();

  const updateAddress = async (input: UpdateOrderAddressInput): Promise<void> => {
    orders.putDetail(await mutation.mutateAsync(input));
  };

  return { updateAddress, isPending: mutation.isPending };
};
